<!--A plain title and text with background banner color.
    Requires:
    - Title
    - Text
    - Choice of background color
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid>
      <mdb-row>
        <mdb-col>
          <mdb-container>
            <mdb-row class="py-5 px-2">
              <mdb-col class="text-left">
                <h3><strong>{{block.value.title_and_text.title}}</strong></h3>
                <p>{{block.value.title_and_text.text}}</p>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import {
    mdbContainer,
    mdbRow,
    mdbCol
} from "mdbvue"
export default {
    name: "title_and_text_banner",
    props: {
        block: Object,
    },
    components: {
        mdbContainer,
        mdbRow,
        mdbCol
    },
};
</script>